import { styled } from '@linaria/react';
import { fonts, layout, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div<{ $error?: boolean; $bare?: boolean }>`
  display: flex;
  align-items: stretch;
  border: ${(p) =>
    p.$bare
      ? 'none'
      : `${p.$error ? size.stroke['stroke-thick'] : size.stroke['stroke-default']} solid ${
          p.$error ? semantic.border.danger : semantic.border.default
        }`};
  border-radius: ${(p) => (p.$bare ? '0' : size.radius['radius-md'])};
  box-sizing: border-box;
  width: 100%;
  position: relative;
  z-index: 1;

  &:focus-within {
    z-index: 100;
  }
`;

export const CountryCodeWrapper = styled.div<{ $bare?: boolean }>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  z-index: 10;

  && > div {
    width: auto;
    flex-direction: row;
    align-items: center;
  }

  && button[aria-haspopup='listbox'] {
    display: inline-flex;
    align-items: center;
    border: none;
    border-right: ${(p) =>
      p.$bare ? 'none' : `${size.stroke['stroke-default']} solid ${semantic.border.default}`};
    border-radius: ${(p) =>
      p.$bare ? '0' : `${size.radius['radius-md']} 0 0 ${size.radius['radius-md']}`};
    background: transparent;
    min-width: unset;
    width: auto;
    padding: ${layout.inputPadding};
    gap: ${space['space-300']};
    font-size: ${fonts.size.base};
    color: ${semantic.text.primary};

    &:focus,
    &[data-open='true'] {
      background: ${semantic.bg.surfaceSubtle};
    }
  }

  && [role='listbox'] {
    left: 0;
    right: auto;
    min-width: 260px;
    max-width: 320px;
    top: calc(100% + ${space['space-100']});
  }
`;

export const FlagCircle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${fonts.size.lg};
  line-height: 1;
`;
